<!-- App.vue -->
<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'

export default {
  components: { DefaultLayout, BlankLayout },
  computed: {
    layout() {
      return this.$route.meta.layout || 'DefaultLayout'
    }
  }
}
</script>
<!-- AUCUN style ici -->